// Hardware product ids and their product type names.
// The id comes from a device hardware record, as `device.hardware.productId`
// or `rawData[deviceId].hardware.productId`.

const PRODUCT_TYPES = {
    "6875f0bf-157d-332e-883f-70e58401dd14": "TIM",
    "62d3da73-debf-8660-5fb4-f5d6c646358f": "TIM+",
    "2d5ef6ed-051c-0bb9-70a4-718d31215e0e": "FLO",
    "9c6047be-d288-4faa-8a2a-5f595f4fd339": "TIM-4",
    "cb1a34bf-e4ea-a74b-d496-37c1183ffa97": "BAT-TIM",
    "4b357a17-cc2d-5d63-116f-a539a78a2802": "POE TIM+",
    "6a36e934-426c-025f-a025-89bed058974d": "POE TIM",
    "85939db1-afba-b79e-b424-2e295ec2a9b5": "POE FLO",
};

// Returns "--" for an unknown id, the same fallback the device cards show.
export function productTypeFromProductID(productId) {
    return PRODUCT_TYPES[productId] || "--";
}

export default PRODUCT_TYPES;
